import React from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { updateExtrusionSettings, setShowSupportPillars } from '../../features/ui/uiSlice';

const PropertyCheckbox: React.FC<{
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = ({ label, checked, onChange }) => {
  return (
    <label className="flex items-center space-x-2 cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="w-4 h-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
      />
      <span className="text-sm text-gray-700 dark:text-gray-300">{label}</span>
    </label>
  );
};

const Depths3DPanel: React.FC = () => {
  const dispatch = useAppDispatch();
  const extrusionSettings = useAppSelector((state) => state.ui.extrusionSettings);
  const showSupportPillars = useAppSelector((state) => state.ui.showSupportPillars ?? false);

  return (
    <div className="p-4">
      <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">3D Depths & Visibility</h2>
      <div className="space-y-4">
        <div className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-2">
          3D Structure & Extrusion
        </div>
        <div className="space-y-2">
          <PropertyCheckbox
            label="Show Support Pillars & Rods"
            checked={showSupportPillars}
            onChange={(checked) => dispatch(setShowSupportPillars(checked))}
          />
          <PropertyCheckbox
            label="Extrude Walls"
            checked={extrusionSettings.walls}
            onChange={(checked) => dispatch(updateExtrusionSettings({ walls: checked }))}
          />
          <PropertyCheckbox
            label="Extrude Equipment"
            checked={extrusionSettings.equipment}
            onChange={(checked) => dispatch(updateExtrusionSettings({ equipment: checked }))}
          />
          <PropertyCheckbox
            label="Extrude Furniture"
            checked={extrusionSettings.furniture}
            onChange={(checked) => dispatch(updateExtrusionSettings({ furniture: checked }))}
          />
          <PropertyCheckbox
            label="Extrude Tracks"
            checked={extrusionSettings.tracks}
            onChange={(checked) => dispatch(updateExtrusionSettings({ tracks: checked }))}
          />
        </div>
      </div>
    </div>
  );
};

export default Depths3DPanel;
